// extracted by mini-css-extract-plugin
module.exports = {"button":"ExtraInfoButton_button__aaYxn","container":"ExtraInfoButton_container__IWgbb","iconVertical":"ExtraInfoButton_iconVertical__TskyQ","icon":"ExtraInfoButton_icon__1krAt"};